import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ORGANIZED_TOURS, useSearch } from "../../../contexts/SearchContext";

/**
 * Forces a fresh child route tree when switching between search / results / profile so
 * profile layout cannot remain mounted while the URL points at results (React Router + memo boundaries).
 */
export default function OrganizedToursKeyedOutlet() {
  const { pathname } = useLocation();
  const { searchResults, isSearched, searchTab } = useSearch();

  const hasResultsSession =
    searchTab === ORGANIZED_TOURS &&
    isSearched === true &&
    Array.isArray(searchResults) &&
    searchResults.length > 0;

  useEffect(() => {
    if (!import.meta.env?.DEV) return undefined;
    console.log("[ORG_TOUR_ROUTE_RENDER_TRACE]", {
      component: "OrganizedToursKeyedOutlet",
      phase: "mounted",
      location: { pathname },
      dealId: null,
      hasResultsSession,
    });
    return () => {
      console.log("[ORG_TOUR_ROUTE_RENDER_TRACE]", {
        component: "OrganizedToursKeyedOutlet",
        phase: "unmounted",
        location: { pathname },
        dealId: null,
        hasResultsSession,
      });
    };
  }, [pathname, hasResultsSession]);

  return <Outlet key={pathname} />;
}
